import { render, staticRenderFns } from "./OrderPhone.vue?vue&type=template&id=68625bf8&"
import script from "./OrderPhone.vue?vue&type=script&lang=js&"
export * from "./OrderPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports